module.exports = __webpack_public_path__ + "static/finance-bg-d641f050b4818c53210552a47ba977d1.png";